import { render, staticRenderFns } from "./empRosterPerson.vue?vue&type=template&id=631aa021&scoped=true&"
import script from "./empRosterPerson.vue?vue&type=script&lang=js&"
export * from "./empRosterPerson.vue?vue&type=script&lang=js&"
import style0 from "./empRosterPerson.vue?vue&type=style&index=0&id=631aa021&prod&lang=scss&scoped=true&"
import style1 from "./empRosterPerson.vue?vue&type=style&index=1&id=631aa021&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631aa021",
  null
  
)

export default component.exports